<!-- eslint-disable -->
<template lang="pug">
    .app-sidebar(v-if="!inGames")
        template(v-if="isOpen && user")
            .sidebar
                .sidebar__profile
                    img.sidebar__user-avatar(:src="user.avatar")
                    .sidebar__user-name
                        div {{ user.firstName }}
                        div {{ user.lastName }}
                control-buttons.sidebar__control-buttons
                ul
                    li.sidebar__item
                        router-link.sidebar__link(:to="{name: 'dashboard'}", :exact="true")
                            | {{ $i18n.t('dashboard.dashboard_sidebar_dashboard') }}
                    li.sidebar__item(v-if="$can('viewList', 'school')")
                        router-link.sidebar__link(:to="{name: 'school:list'}")
                            | {{ $i18n.t('dashboard.dashboard_sidebar_schools') }}
                    li.sidebar__item(v-if="$can('viewList', 'course')")
                        router-link.sidebar__link(:to="{name: 'course:list'}")
                            | {{ $i18n.t('dashboard.dashboard_sidebar_courses') }}
                    li.sidebar__item(v-if="isBillingAvailable")
                        a.sidebar__link(
                            href="javascript://",
                            :class=`{
                                'sidebar__link--active': isSubmenusOpened['billing'],
                                'sidebar__link--opened': $route.name.includes('billing'),
                            }`
                            @click="toggle('billing')"
                        )
                            | {{ $i18n.t('dashboard.dashboard_sidebar_billing') }}
                        ul.sidebar__submenu(:style="submenusStyles['billing']", ref="billing")
                            li.sidebar__submenu-item
                                router-link.sidebar__submenu-link(:to="{name: 'transactions:list'}")
                                    div.sidebar__icon-container
                                        svg-icon(name="angle", size="x-small")
                                    span {{ $i18n.t('dashboard.dashboard_sidebar_transactions') }}
                            template(v-if="isShowBillingSidebar")
                                li.sidebar__submenu-item
                                router-link.sidebar__submenu-link(:to="{name: 'statistics:list'}")
                                    div.sidebar__icon-container
                                        svg-icon(name="angle", size="x-small")
                                    span {{ $i18n.t('dashboard.dashboard_sidebar_statistics') }}
                                li.sidebar__submenu-item
                                    router-link.sidebar__submenu-link(:to="{name: 'stocks:list'}")
                                        div.sidebar__icon-container
                                            svg-icon(name="angle", size="x-small")
                                        span {{ $i18n.t('dashboard.dashboard_sidebar_stocks') }}
                                li.sidebar__submenu-item
                                    router-link.sidebar__submenu-link(:to="{name: 'payment-services:list'}")
                                        div.sidebar__icon-container
                                            svg-icon(name="angle", size="x-small")
                                        span {{ $i18n.t('dashboard.dashboard_sidebar_paymentServices') }}
                                li.sidebar__submenu-item
                                    router-link.sidebar__submenu-link(:to="{name: 'subscriptions:list'}")
                                        .sidebar__icon-container
                                            svg-icon(name="angle", size="x-small")
                                        span {{ $i18n.t('dashboard.dashboard_sidebar_subscriptions') }}
                    li.sidebar__item(v-if="user.type !== 'student'" )
                        router-link.sidebar__link(:to="{name: 'tariffs:list'}")
                            | {{$i18n.t('router.router_tariffs')}}
                    li.sidebar__item(v-if="user.type === 'teacher'")
                        router-link.sidebar__link(:to="{name: 'user:list', params: {type: 'student'}}")
                            | {{ $i18n.t('dashboard.dashboard_sidebar_profilesStudents') }}
                    li.sidebar__item(v-if="user.type !== 'olympiads-student' && user.type !== 'admin'")
                        router-link.sidebar__link(:to="{name: 'trainer:main'}")
                            | {{ $i18n.t('dashboard.dashboard_sidebar_trainer') }}
                    li.sidebar__item(v-if="$can('viewList', 'lesson-conducting-template') && !isFreeTariffTeacher")
                        router-link.sidebar__link(:to="{name: 'lesson-conducting-template:list'}")
                            | {{ $i18n.t('trainer.trainer_main_lessonConducting') }}
                    li.sidebar__item(v-if="isEducationMaterialsAvailable")
                        router-link.sidebar__link(:to="{name: 'education-materials:main'}", :exact="true")
                            | {{ $i18n.t('dashboard.dashboard_sidebar_educationMaterials') }}
                    li.sidebar__item(v-if="$can('viewList', 'homework')")
                        a.sidebar__link(
                            href="javascript://",
                            :class=`{
                                'sidebar__link--active': isSubmenusOpened['homework'],
                                'sidebar__link--opened': $route.name.includes('homework'),
                            }`
                            @click="toggle('homework')"
                        )
                            | {{ $i18n.t('dashboard.dashboard_sidebar_homework') }}
                        ul.sidebar__submenu(:style="submenusStyles['homework']", ref="homework")
                            li.sidebar__submenu-item(v-if="$can('viewList', 'homework')")
                                router-link.sidebar__submenu-link(:to="{name: 'homework:list'}")
                                    div.sidebar__icon-container
                                        svg-icon(name="angle", size="x-small")
                                    span {{ $i18n.t('dashboard.dashboard_sidebar_list') }}
                            li.sidebar__submenu-item(v-if="$can('viewList', 'homework-template') && !isFreeTariffTeacher")
                                router-link.sidebar__submenu-link(:to="{name: 'homework-template:list'}")
                                    div.sidebar__icon-container
                                        svg-icon(name="angle", size="x-small")
                                    span {{ $i18n.t('dashboard.dashboard_sidebar_templates') }}
                    li.sidebar__item
                        router-link.sidebar__link(:to="{name: 'olympiads:index'}")
                            | {{ $i18n.t('dashboard.dashboard_sidebar_olympiads') }}
                    li.sidebar__item(
                        v-if="canShowBattle && (user.isSuperadmin || user.isManagerOrSupport || user.type === 'student')"
                    )
                        router-link.sidebar__link(
                            :to="{name: (user.isSuperadmin || user.isManagerOrSupport ? 'battles:index' : 'battles:main')}"
                        )
                            | {{ $i18n.t('dashboard.dashboard_sidebar_battle') }}
                    li.sidebar__item(v-if="isToolsAvailable")
                        a.sidebar__link(
                            :class=`{
                                'sidebar__link--active': isSubmenusOpened['tools'],
                                'sidebar__link--opened': $route.name.includes('tools'),
                            }`
                            @click.prevent="toggle('tools')"
                        )
                            | {{ $i18n.t('dashboard.dashboard_sidebar_tools') }}
                        ul.sidebar__submenu(:style="submenusStyles['tools']", ref="tools")
                            router-link(v-if="isMentalArithmeticToolsAvailable" ).sidebar__submenu-link(:to="{name: 'tools/abacus:settings'}")
                                .sidebar__icon-container
                                    svg-icon(name="angle", size="x-small")
                                span {{ $i18n.t('dashboard.dashboard_sidebar_abacus') }}
                            router-link(v-if="isFastReadingAndOnlineSchoolToolsAvailable" ).sidebar__submenu-link(:to="{name: 'tools/metronome'}")
                                .sidebar__icon-container
                                    svg-icon(name="angle", size="x-small")
                                span {{ $i18n.t('trainer.trainer_gameFormSetting_metronome') }}
                    li.sidebar__item
                        a.sidebar__link(
                            href="javascript://",
                            :class=`{
                                'sidebar__link--active': isSubmenusOpened['progress'],
                                'sidebar__link--opened': $route.name.includes('progress') && !$route.name.includes('-progress'),
                            }`,
                            @click="toggle('progress')"
                        )
                            | {{ $i18n.t('dashboard.dashboard_sidebar_progress') }}
                        ul.sidebar__submenu(:style="submenusStyles['progress']", ref="progress")
                            li.sidebar__submenu-item(v-if="$can('viewList', 'progress-homework')")
                                router-link.sidebar__submenu-link(:to="{name: 'progress', params: {type: 'homework'}}")
                                    .sidebar__icon-container
                                        svg-icon(name="angle", size="x-small")
                                    span {{ $i18n.t('dashboard.dashboard_sidebar_trainer') }}
                            li.sidebar__submenu-item(v-if="$can('viewList', 'progress-olympiad')")
                                router-link.sidebar__submenu-link(:to="{name: 'progress', params: {type: 'olympiad'}}")
                                    .sidebar__icon-container
                                        svg-icon(name="angle", size="x-small")
                                    span {{ $i18n.t('dashboard.dashboard_sidebar_olympiads') }}
                            li.sidebar__submenu-item(v-if="$can('viewList', 'progress-battle') && isProgressBattleAvailable")
                                router-link.sidebar__submenu-link(:to="{name: 'progress', params: {type: 'battle'}}")
                                    .sidebar__icon-container
                                        svg-icon(name="angle", size="x-small")
                                    span {{ $i18n.t('dashboard.dashboard_sidebar_battles') }}
                    li.sidebar__item(v-if="$pointsSystem && user.type !== 'olympiads-student'")
                        a.sidebar__link(
                            href="javascript://",
                            :class=`{
                              'sidebar__link--active': isSubmenusOpened['points-history'],
                              'sidebar__link--opened': $route.name.includes('points-history') && !$route.name.includes('-points-history'),
                            }`,
                            @click="toggle('points-history')"
                        )
                            | {{ $i18n.t('dashboard.dashboard_sidebar_pointsHistory') }}
                        ul.sidebar__submenu(:style="submenusStyles['points-history']", ref="pointsHistory")
                            li.sidebar__submenu-item(v-if="user.type !== 'olympiads-student'")
                                router-link.sidebar__submenu-link(:to="{name: 'points-history', params: {type: 'homework'}}")
                                    div.sidebar__icon-container
                                        svg-icon(name="angle", size="x-small")
                                    span {{ $i18n.t('dashboard.dashboard_sidebar_trainer') }}
                            li.sidebar__submenu-item
                                router-link.sidebar__submenu-link(:to="{name: 'points-history', params: {type: 'olympiad'}}")
                                    div.sidebar__icon-container
                                        svg-icon(name="angle", size="x-small")
                                    span {{ $i18n.t('dashboard.dashboard_sidebar_olympiads') }}
                            li.sidebar__submenu-item(v-if="isPointsHistoryBattleAvailable")
                                router-link.sidebar__submenu-link(:to="{name: 'points-history', params: {type: 'battle'}}")
                                    div.sidebar__icon-container
                                        svg-icon(name="angle", size="x-small")
                                    span {{ $i18n.t('dashboard.dashboard_sidebar_battles') }}
                    li.sidebar__item
                        a.sidebar__link(
                            href="javascript://",
                            :class=`{
                                'sidebar__link--active': isSubmenusOpened['motivation'],
                                'sidebar__link--opened': $route.name.includes('motivation') && !$route.name.includes('motivation'),
                            }`,
                            @click="toggle('motivation')"
                        )
                            | {{ $i18n.t('dashboard.dashboard_sidebar_motivation') }}
                        ul.sidebar__submenu(:style="submenusStyles['motivation']", ref="motivation")
                            li.sidebar__submenu-item(v-if="isMapAvailable")
                                router-link.sidebar__submenu-link(:to="{name: 'map'}")
                                    div.sidebar__icon-container
                                        svg-icon(name="angle", size="x-small")
                                    | {{ $i18n.t('dashboard.dashboard_sidebar_map') }}
                            li.sidebar__submenu-item(v-if="isDetectiveAvailable")
                                router-link.sidebar__submenu-link(:to="{name: 'detective'}")
                                    div.sidebar__icon-container
                                        svg-icon(name="angle", size="x-small")
                                    | {{ $i18n.t('dashboard.dashboard_sidebar_detective') }}
                            li.sidebar__submenu-item(v-if="$can('viewList', 'rating')")
                                router-link.sidebar__submenu-link(:to="{name: 'rating:list'}")
                                    div.sidebar__icon-container
                                        svg-icon(name="angle", size="x-small")
                                    | {{ $i18n.t('dashboard.dashboard_sidebar_rating') }}
                            li.sidebar__submenu-item(v-if="$can('viewList', 'rating')")
                                router-link.sidebar__submenu-link(:to="{name: 'battle-rating:list'}")
                                    div.sidebar__icon-container
                                        svg-icon(name="angle", size="x-small")
                                    | {{ $i18n.t('dashboard.dashboard_sidebar_battleRating') }}
                    template
                        li.sidebar__item(v-if="isMapAvailable")
                            router-link.sidebar__link(:to="{name: 'map'}")
                                | {{ $i18n.t('dashboard.dashboard_sidebar_map') }}
                        li.sidebar__item(v-if="isDetectiveAvailable")
                            router-link.sidebar__link(:to="{name: 'detective'}")
                                | {{ $i18n.t('dashboard.dashboard_sidebar_detective') }}
                    li.sidebar__item(v-if="isMapAvailable && isDetectiveAvailable")
                        a.sidebar__link(
                            href="javascript://",
                            :class=`{
                                'sidebar__link--active': isSubmenusOpened['histories-progress'],
                                'sidebar__link--opened': $route.name.includes('histories-progress'),
                            }`,
                            @click="toggle('histories-progress')"
                        )
                            | {{ $i18n.t('dashboard.dashboard_sidebar_historiesProgress') }}
                        ul.sidebar__submenu(:style="submenusStyles['histories-progress']", ref="historiesProgress")
                            li.sidebar__submenu-item
                                router-link.sidebar__submenu-link(:to="{name: 'histories-progress', params: {type: 'miles'}}")
                                    div.sidebar__icon-container
                                        svg-icon(name="angle", size="x-small")
                                    span {{ $i18n.t('dashboard.dashboard_sidebar_miles') }}
                            li.sidebar__submenu-item
                                router-link.sidebar__submenu-link(:to="{name: 'histories-progress', params: {type: 'detective'}}")
                                    div.sidebar__icon-container
                                        svg-icon(name="angle", size="x-small")
                                    span {{ $i18n.t('dashboard.dashboard_sidebar_detectivePoints') }}
                    li.sidebar__item(v-else-if="isMapAvailable")
                        router-link.sidebar__link(:to="{name: 'histories-progress', params: {type: 'miles'}}")
                                    span {{ $i18n.t('dashboard.dashboard_sidebar_miles') }}
                    li.sidebar__item(v-else-if="isDetectiveAvailable")
                        router-link.sidebar__link(:to="{name: 'histories-progress', params: {type: 'detective'}}")
                                    span {{ $i18n.t('dashboard.dashboard_sidebar_detectivePoints') }}
                    template(v-else)
                        li.sidebar__item(v-if="isMapAvailable")
                            router-link.sidebar__link(:to="{name: 'miles-history:list'}")
                                | {{ $i18n.t('dashboard.dashboard_sidebar_miles') }}
                        li.sidebar__item(v-else-if="isDetectiveAvailable")
                            router-link.sidebar__link(:to="{name: 'detective-points-history:list'}")
                                | {{ $i18n.t('dashboard.dashboard_sidebar_detectivePoints') }}
                    li.sidebar__item(v-if="user.type !== 'olympiads-student'")
                        router-link.sidebar__link(:to="{name: 'timetable'}")
                            | {{ $i18n.t('dashboard.dashboard_sidebar_timetable') }}
                    li.sidebar__item(v-if="!canShowConversations")
                        router-link.sidebar__link(:to="{name: 'conversations'}", :class="{'is-open':  $route.name.includes('messages')}")
                            | {{ $i18n.t('dashboard.dashboard_sidebar_conversations') }}
                            span.sidebar__messages-amount(v-if="amountOfUnread > 0") &nbsp;({{ amountOfUnread }})
                    li.sidebar__item(v-if="user.type !== 'olympiads-student'")
                        a.sidebar__link(href="https://zoom.us/signin", target="_blank")
                            | {{ $i18n.t('dashboard.dashboard_sidebar_zoom') }}
                    li.sidebar__item
                        router-link.sidebar__link(:to="{name: 'support'}")
                            | {{ $i18n.t('dashboard.dashboard_sidebar_technicalSupport') }}
                            span.sidebar__messages-amount(v-if="amountOfActive > 0") &nbsp;({{ amountOfActive }})
                    li.sidebar__item.sidebar__item--exit
                        a.sidebar__link(href="javascript://" @click="logOut")
                            | {{ $i18n.t('dashboard.dashboard_appHeader_menuExit') }}
                .sidebar__button-container
                    .sidebar__button
                        cs-button(
                            type="submit"
                            color="white"
                            @click="$emit('toggleSidebar')"
                        )
                            .button__icon(slot="icon")
                                svg-icon(name="angle" size="small", height="xx-small")
                            | {{ $i18n.t('dashboard.dashboard_sidebar_rollUp') }}
            .sidebar__menu-container
                .sidebar__menu-icon.sidebar__menu-icon--flip-horizontal(@click="$emit('toggleSidebar')")
                    svg-icon(name="close-menu", size="xxx-large")
        .sidebar__menu-container.sidebar__menu-container--show-md(v-else)
            .sidebar__menu-icon(@click="$emit('toggleSidebar')")
                svg-icon(name="open-menu", size="xxx-large")
            .sidebar__menu-icon.sidebar__menu-icon--sticky(@click="$emit('toggleSidebar')")
                svg-icon(name="close-menu", size="xxx-large")
</template>

<script>
    /*eslint-disable*/
    import {mapState} from 'vuex'
    import canShowConversations from '../../utils/user/canShowConversations';
    import courseAccesses from '../../utils/user/courseAccesses';
    import ControlButtons from './ControlButtons.vue';
    import Api from '../../api'
    import MessageApi from '../../api/communication/message'
    import amountOfMessages from '../../utils/communication/amountsOfMessages'
    import amountOfTickets from '../../utils/communication/amountsOfTickets'
    import canShowBattle from '../../utils/battle/canShowBattle'
    import { TARIFF_IDS_WITH_PLAY_TIME_LIMIT } from '@/config/tariff_constants';

    const MENU_LINK_HEIGHT = 50;
    const COURSES_WITH_METRONOME = ['fastReading', 'onlineSchool'];
    const COURSES_WITH_TOOLS = ['mentalArithmetic', 'fastReading', 'onlineSchool'];
    export default {
        props: {
            isOpen: {
                type: Boolean,
                default: true
            },
            inGames: {
                type: Boolean,
                default: false,
            }
        },
        mixins: [amountOfMessages, amountOfTickets, courseAccesses, canShowConversations, canShowBattle],
        components: {ControlButtons},
        data() {
            return {
                openedSubmenus: [],
                submenus: [
                    'billing',
                    'homework',
                    'progress',
                    'points-history',
                    'motivation',
                    'histories-progress',
                    'tools',
                ],
            }
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
                selectedCourse: state => state.trainer.course
            }),
            isSubmenusOpened () {
                return this.submenus.reduce((acc, name) => {
                    acc[name] = (this.$route.path.startsWith('/' + name) || this.openedSubmenus.includes(name)) && this.isOpen;
                    return acc;
                }, {});
            },
            submenusStyles () {
                return this.submenus.reduce((acc, name) => {
                    const camelCaseName = _.camelCase(name);
                    const height = (!this.isSubmenusOpened[name] || !this.$refs[camelCaseName])
                            ? 0
                            : this.$refs[camelCaseName].children.length * MENU_LINK_HEIGHT + 'px';
                    acc[name] = { maxHeight: height, marginTop: height ? 0 : '-15px' };
                    return acc;
                }, {});
            },
            isMapAvailable () {
                return this.$isMapAvailable && this.courseAllowMap
                        && (
                                (this.user.type === 'student' || this.user.type === 'olympiad-student')
                                        ? this.selectedCourse === 'mentalArithmetic'
                                        : true
                        );
            },
            isDetectiveAvailable () {
                return this.$isDetectiveAvailable && this.courseAllowDetective
                        && (
                                (this.user.type === 'student' || this.user.type === 'olympiad-student')
                                        ? this.selectedCourse === 'fastReading'
                                        : true
                        );
            },
            isEducationMaterialsAvailable () {
                return (this.user.type !== 'student' && this.user.type !== 'olympiad-student')
                        && this.user.isEducationMaterialsAvailable;
            },
            isBillingAvailable () {
                return this.user.schools.some(school => school.mainContactId === this.user.id && school.isBillingActive)
                        || this.user.isSuperadmin || this.user.isManagerOrSupport;
            },
            isToolsAvailable () {
                return  (this.user.isSuperadmin || this.user.type !== 'admin') && this.user.pointsAccesses.some(access => COURSES_WITH_TOOLS.includes(access))
                        && (this.isMentalArithmeticToolsAvailable || this.isFastReadingAndOnlineSchoolToolsAvailable)
                        ;
            },
            isMentalArithmeticToolsAvailable() {
                if (this.user.isSuperadmin || this.user.isManagerOrSupport) {
                    return true;
                }
                if (this.user.type === 'teacher' || this.user.type === 'admin') {
                    return this.user.pointsAccesses.some(access => access === 'mentalArithmetic')
                }
                return this.selectedCourse === 'mentalArithmetic';
            },
            isFastReadingAndOnlineSchoolToolsAvailable() {
                if (this.user.isSuperadmin || this.user.isManagerOrSupport) {
                    return true;
                }
                if (this.user.type === 'teacher' || this.user.type === 'admin') {
                    return this.user.pointsAccesses.some(access => COURSES_WITH_METRONOME.includes(access));
                }
                return COURSES_WITH_METRONOME.includes(this.selectedCourse);
            },
            isProgressBattleAvailable () {
                return this.user.pointsAccesses.includes('mentalArithmetic')
                        && (
                            this.user.type === 'student'
                                ? this.selectedCourse === 'mentalArithmetic'
                                : true
                        );
            },
            isPointsHistoryBattleAvailable () {
                if (this.user.type === 'olympiad-student') {
                    return false;
                }
                return this.user.pointsAccesses.includes('mentalArithmetic')
                    && (
                        this.user.type === 'student'
                            ? this.selectedCourse === 'mentalArithmetic'
                            : true
                    );
            },
            isShowBillingSidebar () {
                return this.user.isSuperadmin || this.user.isManagerOrSupport;
            },
            isFreeTariffTeacher () {
                if (this.user.type !== 'teacher') {
                    return false;
                }
                const school = this.user.schools && this.user.schools[0];
                return !!school && TARIFF_IDS_WITH_PLAY_TIME_LIMIT.includes(school.tariffId);
            }
        },
        watch: {
            '$route': {
                handler(to) {
                    if (
                            (!to.path.startsWith('/user') && this.openedSubmenus.includes('profile'))
                            || (!to.path.startsWith('/progress') && this.openedSubmenus.includes('progress'))
                            || (!to.path.startsWith('/points-history') && this.openedSubmenus.includes('points-history'))
                            || (!to.path.startsWith('/histories-progress') && this.openedSubmenus.includes('histories-progress'))
                            || (!to.path.startsWith('/billing') && this.openedSubmenus.includes('billing'))
                    ) {
                        this.openedSubmenus = [];
                    }
                },
                immediate: true
            },
            '$root.amountOfUnread' (val) {
                this.amountOfUnread = val;
            },
            '$root.amountOfActive' (val) {
                this.amountOfActive = val;
            },
            user (user) {
                if (user) {
                    this.$echo.private(`message.${user.id}`).listen('NewMessage', data => {
                        data = Api.convertObjectKeys(data);
                        if (data.message.senderId !== user.id) {
                            MessageApi.list({
                                conversationId: data.message.conversationId,
                                amountOfElements: 2
                            }).then(data => {
                                if (
                                        (data.data.length && (data.data.length === 1 || !data.data[1].unread))
                                        && this.$route.fullPath.indexOf('conversation') === -1
                                ) {
                                    this.amountOfUnread++;
                                }
                            })
                        }
                    });
                    this.$echo.private(`ticket-message.${user.id}`).listen('NewTicketMessage', data => {
                        data = Api.convertObjectKeys(data);
                        if (data.message.senderId !== user.id) {
                            if (this.$route.fullPath.indexOf('support') === -1
                                    && data.message.ticket.createdAt === data.message.ticket.updatedAt) {
                                this.amountOfActive++;
                            }
                        }
                    });
                    this.$echo.private(`ticket.${user.id}`).listen('TicketEvent', data => {
                        data = Api.convertObjectKeys(data);
                        if (this.$route.fullPath.indexOf('support') === -1) {
                            if (data.ticket.deletedAt && data.ticket.status) {
                                this.amountOfActive--;
                                return;
                            }
                            data.ticket.status ? this.amountOfActive++ : this.amountOfActive--;
                        }
                    });
                }
            },
        },
        methods: {
            toggle (to) {
                if (!this.isOpen) {
                    this.$emit('toggleSidebar');
                }
                if (!this.openedSubmenus.includes(to)) {
                    this.openedSubmenus.push(to);
                } else {
                    if (this.isOpen) {
                        this.openedSubmenus = _.clone(_.pull(this.openedSubmenus, to));
                    }
                }
            },
            logOut () {
                this.$router.push({name: 'dashboard'});
                this.$store.dispatch('logOut');
            },
        }
    }
</script>

<style lang="scss" scoped>
    .app-sidebar {
        overflow-y: auto;
        overflow-x: hidden;
        display: flex;
        flex: 1 1 auto;
        justify-content: space-between;
        @include media($xlg) {
            overflow: inherit;
            flex-direction: column;
        }
    }

    .sidebar {
        width: $sidebar-open-width;
        display: flex;
        flex: 1 1 auto;
        flex-direction: column;
        box-sizing: border-box;

        @include media($md) {
            padding: 30px 0;
        }

        @include media($xlg) {
            padding: 0;
            justify-content: space-between;
        }
    }

    .sidebar__menu-container {
        padding: 30px 0;
        @include media($xlg) {
            display: none;
        }
    }

    .sidebar__menu-container--show-md {
        padding: 0;
        display: none;
        @include media($md) {
            display: flex;
            flex: 1 1 auto;
            flex-direction: column;
            justify-content: space-between;
        }
    }

    .sidebar__button-container {
        display: flex;
        flex: 1 1 auto;
        align-items: flex-end;
    }

    .sidebar__button {
        font-weight: 500;
        margin: 30px 40px 0 40px;
        display: none;
        @include media($xlg) {
            display: block;
            position: sticky;
            bottom: 30px;
        }
    }

    .sidebar__menu-icon {
        padding-left: 35px;
        color: $hsl-color-green-58;
        &:hover {
            color: $x-color-black;
            cursor: pointer;
        }
    }

    .sidebar__menu-icon--sticky {
        @include media($xlg) {
            position: sticky;
            bottom: 30px;
        }
    }

    .sidebar__menu-icon--flip-horizontal {
        padding-left: 20px;
        transform: rotate(0.5turn);
    }

    .sidebar__link, .sidebar__submenu-link {
        padding: 15px 40px 15px 34px;

        box-sizing: border-box;

        width: 100%;
        display: flex;
        white-space: nowrap;

        font-size: 16px;
        line-height: 20px;

        border-left: 6px solid transparent;

        color: $x-color-white;
    }

    .sidebar__item--exit {
        display: block;
        @include media($md) {
            display: none;
        }
    }

    .sidebar__submenu-link {
        padding: 10px 40px 10px 34px;
    }

    .sidebar__link {
        cursor: pointer;
        &.is-open {
            font-weight: 500;
            background: $hsl-color-green-48;
            border-radius: 0 40px 40px 0;
            border-left: 6px solid $hsl-color-yellow-66;
        }
    }

    .sidebar__link--opened {
        font-weight: 500;
        background: $hsl-color-green-48;
        border-radius: 0 40px 40px 0;
        border-left: 6px solid $hsl-color-yellow-66;
    }

    .sidebar__submenu {
        margin-left: 15px;
        margin-top: -15px;
        margin-bottom: 15px;
        transition: max-height 0.2s ease-in-out;
        overflow: hidden;
    }

    .sidebar__icon-container {
        display: inline-block;
        vertical-align: middle;
        font-size: 18px;
        height: 18px;
        margin-right: $space-small;
        color: $x-color-white;
        transition: color 0.25s;
        transform: rotate(-0.25turn);
    }

    .button__icon {
        display: inline-block;
        margin-right: $space-x-small;
        color: $x-color-black;
        transition: color 0.25s;
        transform: rotate(0.25turn);
    }

    .sidebar__profile {
        width: 100%;
        display: flex;
        align-items: center;
        padding: 30px 0 30px 30px;
        box-sizing: border-box;
        @include media($md) {
            display: none;
        }
    }

    .sidebar__user-avatar {
        border-radius: 50%;
        max-height: none;
        height: 60px;
        width: 60px;
        border: 6px solid rgba($hsl-color-gray-100, 0.2);
    }

    .sidebar__user-name {
        padding-left: 20px;
        font-weight: 500;
        color: $x-color-white;
    }

    .sidebar__control-buttons {
        display: block;
        flex-direction: column;
        margin: -10px 0 10px 40px;
        @include media($xlg) {
            display: none;
        }
    }

    .sidebar__messages-amount {
        font-size: $font-size-14;
        font-weight: 500;
        line-height: 20px;
    }
</style>
